<template>
  <section class="product-prices" id="pricing">
    <header>
      <h2>{{$t('products.price')}}</h2>
    </header>
    <div class="text-center">
    <!--   eslint-disable   -->
      <div class="product-prices-table">
        <div class="row is-mobile first-line">
          <div class="col-xs-2 col-xs-offset-1">{{$t('orders.labelBinding')}}</div>
          <div class="col-xs-2">A5 {{$t('book.bindingPaperback')}}</div>
          <div class="col-xs-2">A5 {{$t('book.bindingHardback')}}</div>
          <div class="col-xs-2">A4 {{$t('book.bindingPaperback')}}</div>
          <div class="col-xs-2">A4 {{$t('book.bindingHardback')}}</div>
        </div>
        <div class="row is-mobile">
          <div class="col-xs-2 col-xs-offset-1">{{$t('products.innerPagePrice')}}</div>
          <template v-if="prices">
            <div class="col-xs-2 content">{{symbols}}{{prices['a5']['paperback'].inner}}</div>
            <div class="col-xs-2 content">{{symbols}}{{prices['a5']['hardback'].inner}}</div>
            <div class="col-xs-2 content">{{symbols}}{{prices['a4']['paperback'].inner}}</div>
            <div class="col-xs-2 content">{{symbols}}{{prices['a4']['hardback'].inner}}</div>
          </template>
          <template v-else>
            <div class="col-xs-2" v-for="(item, index) in 4" :key="index">
              {{$t('products.loading')}}
            </div>
          </template>
        </div>
        <div class="row">
          <div class="col-xs-2 col-xs-offset-1">{{$t('products.innerPageMaterial')}}</div>
          <div class="col-xs-2 content">{{$t('products.matteImportPaper')}}</div>
          <div class="col-xs-2 content">{{$t('products.matteCrystalPaper')}}</div>
          <div class="col-xs-2 content">{{$t('products.matteImportPaper')}}</div>
          <div class="col-xs-2 content">{{$t('products.matteCrystalPaper')}}</div>
        </div>
        <div class="row is-mobile">
          <div class="col-xs-2 col-xs-offset-1">{{$t('products.innerPackaging')}}</div>
          <div class="col-xs-2 content">{{$t('products.fabricBag')}}</div>
          <div class="col-xs-2 content">{{$t('products.giftBox')}}</div>
          <div class="col-xs-2 content">{{$t('products.fabricBag')}}</div>
          <div class="col-xs-2 content">{{$t('products.giftBox')}}</div>
        </div>
        <div class="row is-mobile">
          <div class="col-xs-2 col-xs-offset-1">{{$t('products.outerPackaging')}}</div>
          <div class="col-xs-2 content">{{$t('products.a5Box')}}</div>
          <div class="col-xs-2 content">{{$t('products.a5Box')}}</div>
          <div class="col-xs-2 content">{{$t('products.a4Box')}}</div>
          <div class="col-xs-2 content">{{$t('products.a4Box')}}</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: '',
  props: {
    prices: Object,
    symbols: String
  },
  data: () => ({
  }),
  computed: {},
  created () {},
  methods: {}
}
</script>

<style lang="scss">
@import '../../styles/variables';
.product-prices {
  &-table {
    .row.first-line {
      .col-xs-2 {
        background-color: rgba($el-color-primary, 0.08);
        color: $el-color-primary;
        font-weight: 600;
      }
    }
    .col-xs-2 {
      padding: .75rem 0;
      border: 1px solid rgba($el-color-primary, 0.1);
      &.content {
        font-weight: 500;
      }
    }
    .col-xs-2 + .col-xs-2 {
      border-left: 1px solid rgba($el-color-primary, 0.1);
    }
  }

  @media (max-width: 768px) {
    &-table {
      font-size: 0.7rem;
      line-height: 1.25;

      .row {
        display: flex;
        align-items: stretch;
        margin-left: 0;
        margin-right: 0;
      }

      .col-xs-2,
      .col-xs-2.col-xs-offset-1 {
        padding: 0.5rem 0.2rem;
        word-wrap: break-word;
        overflow-wrap: anywhere;
        hyphens: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
      }
    }
  }
}
</style>
